import PragmaticTournament from './PragmaticTournament';

export default PragmaticTournament;
